import "./ProgressBar.scss";

const ProgressBar = ({ progress, title }) => {
  return (
    <div className="progress-bar">
      <p>{title}</p>
      <div className="progress-bar-container">
        <div
          className="progress-bar-container-value"
          style={{ width: `${progress}%` }}
          aria-valuenow={progress}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
